'use client'

import React, { useCallback } from 'react'
import { postProcessor } from './post-processors'

type Props = {
  children: React.ReactNode
}

export const BasicMacroContentProvider = ({ children }: Props) => {
  const postProcessorRef = useCallback((el: any) => {
    if (el) {
      postProcessor(el)
    }
  }, [])

  return <div ref={postProcessorRef}>{children}</div>
}
